// router
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';

// i18next
import { useTranslation } from 'react-i18next';
// @mui
import { useTheme } from '@mui/material/styles';
import {
  Box,
  Typography,
  Stack,
  MenuItem,
  Avatar,
  ListItemIcon, ListItemText,
} from '@mui/material';

// hooks
import useAuth from '../../hooks/useAuth';
import { useRouter } from '../../hooks/useRoutes';

// utils
import { getAssetsUrl, getImageUrl, getPictureUrl } from '../../utils/@helper/file.helper';
import { SvgArrowNarrowRightFill, SvgChatDotFill, SvgLogoutFill, SvgIUserFill, SvgChatFill, SvgSignFill } from '../../components/SvgIcons';
import { IconPopover } from '../@popover/IconPopover';
import { toggleFeedbackListDrawer } from '../../store/actions/feebackActions';
import { fDateYear } from '../../utils/formatTime';




/* ======================================================================== */

export default function AccountPopover({ existToken }) {
  const { t } = useTranslation();
  const theme = useTheme();
  const navigator = useNavigate();
  const dispatch = useDispatch();
  const { logOut } = useAuth();
  const { onSessionLogin } = useRouter();

  const [searchParams, setSearchParams] = useSearchParams();
  // 判斷是否重定向
  const redirectUrl = searchParams.get('redirect')?.trim();

  const { account: { profile }, feedback: { existFeedback } } = useSelector(
    (state) => state
  );

  const MENU_OPTIONS = [
    {
      lng: '個人基本資料',
      label: `個人基本資料`,
      icon: <SvgIUserFill color={theme.palette.text.secondary} />,
      action: () => {
        navigator('/honhai/user/user_basic_information')
      }
    },
    {
      lng: '簽核中心',
      label: `簽核中心`,
      icon: <SvgSignFill />,
      action: () => {
        navigator('/honhai/sign-off?catalogs=sign_off_waiting')
      }
    },
    {
      lng: '有話要說',
      label: `有話要說`,
      icon: existFeedback > 0 ? <SvgChatDotFill /> : <SvgChatFill />,
      action: () => {
        dispatch(toggleFeedbackListDrawer(true))
        // dispatch(toggleFeedbackDrawer(true));
      }
    },
    {
      lng: '登出',
      label: t('ese.logout'),
      icon: <SvgLogoutFill />,
      action: async () => { await logOut() }
    }
  ];

  return existToken ? (
    <>
      <IconPopover
        position={{ x: '-210px' }}
        primary={
          <Box width={'100%'} height={'100%'} display={'flex'} alignItems={'center'}>
            <Avatar src={profile?.avatar ? getPictureUrl(profile?.avatar) : getAssetsUrl('images/icons/icon-profile-white.svg') } alt={profile?.realname} sx={{ width: 24, height: 24 }} />
            {/* <Typography variant={'body1'} ml={0.5} color={theme.palette.text.primary}>{profile?.realname}</Typography> */}
          </Box>
        }
        content={ 
          <>
            <Box pt={4} pb={1} px={3} minWidth={296}>
              <Stack direction={'row'} alignItems={'center'} spacing={1.5} mb={1}>
                <Avatar src={profile?.avatar ? getPictureUrl(profile?.avatar) : getAssetsUrl('images/avatars/avatar_ellipse.png')} alt={profile?.realname} sx={{ width: 48, height: 48 }} />
                <Box>
                  <Typography variant="h6" color={"common.black"} noWrap>
                    {profile?.realname}
                  </Typography>
                  <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
                    {profile?.email}
                  </Typography>
                </Box>
              </Stack>
              <Stack>
                {_.map(MENU_OPTIONS, (option, index) => (
                  <Box key={index} sx={{ ...theme.typography.hoverPrimaryLeftline2px }}>
                    <MenuItem
                      key={option.label}
                      onClick={option.action}
                      sx={{
                        py: 1,
                        pl: 1.5,
                        pr: 2,
                        '& .Sim-account-item-arrow': { opacity: 0, transition: 'all 0.5s'},
                        '& .Sim-account-item-icon': { minWidth: 24, height: 24, alignItems: 'center', justifyContent: 'center', mr: 0.4 },
                        '& .Sim-account-item-text': { color: 'common.black', transition: 'all 0.5s' },
                        '&:hover': {
                          '& svg': {
                            fill: theme => theme.palette.action.selected,
                            color: theme => theme.palette.action.selected,
                          },
                          '& .Sim-account-item-text': { color: theme.palette.action.selected },
                          '& .Sim-account-item-arrow': { opacity: 1 },
                        }
                      }}
                    >
                      <ListItemIcon className={'Sim-account-item-icon'}>
                        { option?.icon }
                      </ListItemIcon>
                      <ListItemText className={'Sim-account-item-text'} primaryTypographyProps={{ ...theme.typography.subtitle1, fontWeight: 700 }}>
                        { option.label }
                      </ListItemText>
                      <SvgArrowNarrowRightFill className={'Sim-account-item-arrow'} color={theme.palette.action.selected} />
                    </MenuItem>
                  </Box>
                ))}
              </Stack>
            </Box>
            <Typography
              component={'div'}
              variant={'caption'}
              py={1}
              borderTop={`1px solid #CCC`}
              textAlign={'center'}
              color={'text.secondary'}
            >
              版本號 V{ fDateYear(new Date()) }.1
            </Typography>
          </>
        }
      />
    </>
  ) : (
    <IconPopover
      position={{ x: '-210px' }}
      primary={
        <Box width={'100%'} height={'100%'} display={'flex'} alignItems={'center'} onClick={() => onSessionLogin(Boolean(redirectUrl) ? encodeURIComponent(redirectUrl) : null)}>
          <Avatar src={getAssetsUrl('images/icons/icon-profile-white.svg') } alt={'profile'} sx={{ width: 24, height: 24 }} />
          {/* <Typography variant={'body1'} ml={0.5} color={theme.palette.text.primary}>{profile?.realname}</Typography> */}
        </Box>
      }
    />
  );
}
